var React = require('react');

function IconInfo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.1464 0C3.8337 0 .3335 3.584.3335 8s3.5002 8 7.8129 8c4.3127 0 7.8128-3.584 7.8128-8s-3.5001-8-7.8128-8zm.7813 12H7.365V7.2h1.5625V12zm0-6.4H7.365V4h1.5625v1.6z"}));
}

IconInfo.defaultProps = {"fill":"none","viewBox":"0 0 16 16"};

module.exports = IconInfo;

IconInfo.default = IconInfo;
